import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormHexagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-hexagon"} maskId="square-filled-radius-0-stroke-1-IconFormHexagon"><path d="M20.9102 6.56738L21.1602 6.71094V17.2891L20.9102 17.4326L12 22.5771L3.08984 17.4326L2.83984 17.2891V6.71094L3.08984 6.56738L12 1.42285L20.9102 6.56738Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormHexagon;
